import React, { useState, useEffect } from 'react';
import {Button, Form, Card, Row, Col } from "react-bootstrap";
import Swal from 'sweetalert2';
import { ResponseResult, Budget} from '../../types';
import { request } from '../../services/Request';


function BudgetNew(){

    const [budgetData, setBudgetData] = useState<Partial<Budget>>({});
    
    useEffect(()=>{
        document.addEventListener("wheel", function(event){
            const element:any = document.activeElement;
            if(element && element.type === "number"){
                element.blur();
            }
        });
    }, []);
    
    const submit = (e:React.SyntheticEvent) => {
        e.preventDefault();
        Swal.fire("Presupuestos", "Guardando registro...");
        Swal.showLoading();
        request("/api/budget",{
            method: 'POST',
            body: JSON.stringify(budgetData)
        })
        .then((result:ResponseResult)=>{
            Swal.close();
            if(result.data){
                window.location.href="/budget";
            }else{
                Swal.fire("Presupuestos", "Ocurrió un error al guardar el presupuesto", "error");
            }
        })
    }

    const onChange = (e:any)=>{
        let data = budgetData;
        if(e.target.name == 'mount_month' && e.target.value < 0){
            (document.getElementById(e.target.id) as HTMLInputElement).value = '0';
            data[e.target.name] = 0;
        }else{
            data[e.target.name] = e.target.value;
        }
        setBudgetData(data);
    }

    return (
        <div id="movements-form">
            <Row>
                <Col xs={12} md={{span:8,offset:2}}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Nuevo presupuesto</Card.Title>
                            <Form onSubmit={submit}>
                                <Form.Group className="mb-3" controlId="concept">
                                    <Form.Label>Concepto</Form.Label>
                                    <Form.Control required type="text" placeholder="" name="concept" onChange={onChange}/>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="mount_month">
                                    <Form.Label>Monto mensual</Form.Label>
                                    <Form.Control required type="number" step="0.01" placeholder="" name="mount_month" onChange={onChange}/>
                                </Form.Group> 
                                <Row className="mt-5">
                                    <Col xs={12} md={2}>
                                        <Button variant="primary" type="submit" className="w-100">
                                            Crear
                                        </Button>
                                    </Col>
                                    <Col xs={12} md={2}>
                                        <a className="ml-3 btn btn-danger w-100" href="/budget">
                                            Cancelar
                                        </a>
                                    </Col>
                                </Row>

                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}
export default BudgetNew;